import React from "react";
import "./styles/About.css";
import aboutImage from "../assets/p2.jpg"; // used as background via CSS
import profilePic from "../assets/black car.jpg"; // new image

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="overlay">
        <div className="about-text">
          <h2>Who We Are</h2>
          <p>
            <strong>Welcome to <span className="highlight">Airflex RSA</span></strong> — your ultimate car customization partner!
          </p>
          <p>
            <strong>Founded in 2024</strong> by <strong>Mr. Nevhulaudzi U and Mr. Lusunzi G</strong>, Airflex RSA is a proudly South African automotive customization and repair company based in <strong>Shayandima, Thohoyandou, Limpopo</strong>.
          </p>
          <p>
            At <strong>Airflex RSA</strong>, we believe your car should not only perform at its best — it should reflect your unique style. We go beyond standard repairs to offer <strong>advanced customization solutions</strong> tailored to your vision.
          </p>
          <p>
            We are proud to offer our very own <strong>Air Suspension Bluetooth Management System</strong> — engineered for unmatched control, performance, and convenience.
          </p>
          <p>
            Whether you're upgrading your <strong>suspension system</strong>, installing a <strong>custom sound setup</strong>, or seeking trusted <strong>maintenance services</strong>, our experienced team is committed to delivering high-quality workmanship and exceptional customer care.
          </p>
          {/* ✅ Profile Picture
          <div className="profile-pic-container">
            <img src={profilePic} alt="Airflex RSA Shop" className="profile-pic" />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default About;
